// Actions
import {
  REQUEST_STARTED,
  REQUEST_SUCCEEDED,
  REQUEST_FAILED,
  REQUEST_TYPE_CHANGE,
  REQUEST_UPDATE_DATA,
} from '../actions/createData';

const init = {
  data: [],
  dataOrig: [],
  type: 'POP',
  error: null,
  request: false,
};

function selectSet(d, state) {
  const newArr = [...d];

  const sort = newArr.sort((a, b) => {
    return b[state.type] - a[state.type];
  });

  // sort.length = 100;
  console.log('sort ', sort);
  return sort;
}

export default function data(state = init, action) {
  switch (action.type) {
    case REQUEST_STARTED:
      return { ...state, request: true };

    case REQUEST_SUCCEEDED:
      return {
        ...state,
        dataOrig: action.data,
        data: selectSet(action.data, state),
      };

    case REQUEST_FAILED:
      return { ...state, request: false, error: action.error };

    case REQUEST_TYPE_CHANGE:
      return { ...state, type: action.code };

    case REQUEST_UPDATE_DATA:
      return {
        ...state,
        data: selectSet(state.data, state),
      };

    default:
      return state;
  }
}
